// Module
var code = "<div>\r\n  404 Page Not Found.\r\n</div>";
// Exports
module.exports = code;